import { __ } from '@wordpress/i18n';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { decodeEntities } from '@wordpress/html-entities';
import { getSetting } from '@woocommerce/settings';
import { useState, useEffect } from 'react';

import { SortCode, AccountNumber, AccountHolder, BBName } from './elements';

import '../../scss/frontend/index.scss';

const settings = getSetting( 'tfa_enc_data', {} );

const defaultLabel = __(
	'Direct Debit',
	'woo-gutenberg-products-block'
);

const label = decodeEntities( settings.title ) || defaultLabel;

/**
 * Content component
 */
const Content = ( props ) => {
	const [sortCode, setSortCode] = useState('');
	const [accountNumber, setAccountNumber] = useState('');
	const [accountHolder, setAccountHolder] = useState('');
	const [bbName, setBBName] = useState('');
	const { eventRegistration, emitResponse } = props;
	const { onPaymentProcessing } = eventRegistration;
	useEffect( () => {
		const unsubscribe = onPaymentProcessing( async () => {
			console.log('checking', sortCode, accountHolder, accountNumber, bbName);
			// Here we can do any processing we need, and then emit a response.
			// For example, we might validate a custom field, or perform an AJAX request, and then emit a response indicating it is valid or not.
			// sortCode needs to be 6 characters, all numeric
			const sortCodeRegex = new RegExp('^[0-9]{6}$', '');
			const sortCodeValid = sortCodeRegex.test(sortCode);
			// accountNumber needs to be 8 characters, all numeric
			const accountNumberRegex = new RegExp('^[0-9]{8}$', '');
			const accountNumberValid = accountNumberRegex.test(accountNumber);
			
			const accountHolderValid = accountHolder.length > 0;
			const bbNameValid = bbName.length > 0;
			console.log(bbName, bbName.length, bbNameValid);
			if ( sortCodeValid && accountNumberValid && accountHolderValid && bbNameValid ) {
				return {
					type: emitResponse.responseTypes.SUCCESS,
					meta: {
						paymentMethodData: {
							sortCode,
							accountNumber,
							accountHolder,
							bbName,
						},
					},
				};
			}
			
			let errorMessage = 'Error:<br><br>';
			if (!sortCodeValid) {
				errorMessage = errorMessage + '<p>Sort Code needs to be 6 numbers - no hyphens or spaces</p>';
			}
			if (!accountNumberValid) {
				errorMessage = errorMessage + '<p>Account Number needs to be 8 numbers - no hyphens or spaces</p>';
			}
			if (!accountHolderValid) {
				errorMessage = errorMessage + '<p>Please enter the name of the Account Holder<p>';
			}
			if (!bbNameValid) {
				errorMessage = errorMessage + '<p>Please enter the name of your Bank/Building Society';
			}

			return {
				type: emitResponse.responseTypes.ERROR,
				message: errorMessage,
			};
		} );
		// Unsubscribes when this component is unmounted.
		return () => {
			unsubscribe();
		};
	}, [
		emitResponse.responseTypes.ERROR,
		emitResponse.responseTypes.SUCCESS,
		onPaymentProcessing,
		sortCode,
		accountNumber,
		accountHolder,
		bbName,
	] );
	// return decodeEntities( settings.description || '' );
	const fieldsetId = 'tfawcdd-' + settings.id + '-dd-form';
	const today = new Date;
	return (
		<>
			<fieldset id={ fieldsetId } className="tfawcdd-direct-debit-form wc-payment-form row">
				<div className='col-12'>
					<img src='/wp-content/plugins/tfa-woo-dd/images/direct-debit-1-logo-png-transparent-cropped-w300.png'
						alt='Direct Debit Logo'
						className='mb-15'
					/>
				</div>
				<div className='col-12 col-sm-6'>
					<h2 className='h5'>Autohome Ltd</h2>
					<p>Mayleigh House<br />
					Orchard Hill<br />
					Little Billing<br />
					Northampton<br />
					NN3 9AD</p>
					<AccountHolder
						accountHolder={accountHolder}
						setAccountHolder={setAccountHolder}
					/>
					<AccountNumber 
						accountNumber={accountNumber}
						setAccountNumber={setAccountNumber}
					/>
					<SortCode
						sortCode={sortCode}
						setSortCode={setSortCode}
					/>
					<BBName
						bbName={bbName}
						setBBName={setBBName}
					/>
					<p>Banks and building societies may not accept Direct Debit Instructions for some types of account.</p>
				</div>
				<div className='col-12 col-sm-6'>
					<h3 className='h6'>Instruction to your Bank or Building Society to pay by Direct Debit</h3>
					<p>
						<strong>Originator's Identification number</strong><br />
						Id number Here
					</p>
					<p>
						<strong>Instructions to your Bank or Building Society</strong><br />
						Please pay Autohome Ltd Direct Debits from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee. I understand that this instruction may remain with Autohome Ltd Ltd and, if so, details will be passed electronically to my Bank/Building Society.
					</p>
					<p>Date: { today.toLocaleDateString() }</p>
				</div>
				<div className='col-12'>
					<h3>The Direct Debit Guarantee</h3>
					<ul>
						<li>The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits</li>
						<li>If there are any changes to the amount, date or frequency of your Direct Debit, the organisation will notify you (normally 10 working days) in advance of your account being debited or as otherwise agreed. If you request the organisation to collect a payment, confirmation of the amount and date will be given to you at the time of the request</li>
						<li>If an error is made in the payment of your Direct Debit, by the organisation or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society</li>
						<li>If you receive a refund you are not entitled to, you must pay it back when the organisation asks you to</li>
						<li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify the organisation</li>
					</ul>
				</div>
			</fieldset>
		</>
	)
};

/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
const Label = ( props ) => {
	const { PaymentMethodLabel } = props.components;
	return <PaymentMethodLabel text={ label } />;
};

/**
 * TFADD payment method config object.
 */
const TFADD = {
	name: "tfa_enc",
	label: <Label />,
	content: <Content />,
	edit: <Content />,
	canMakePayment: () => true,
	ariaLabel: label,
	supports: {
		features: settings.supports,
	},
};

registerPaymentMethod( TFADD );